import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['vin']

  connect() {
    this.vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i
    this.vin.addEventListener('blur', event => { this.fetchInfo(event) })
  }

  fetchInfo(event) {
    if(this.#valid()) {
      this.vin.classList.remove('invalid')
      this.vin.parentNode.querySelector('.error-label')?.remove()
      this.element.requestSubmit()
    } else {
      this.#renderError()
    }
  }

  get vin() { return this.vinTarget }
  #valid() {
    const value = this.vin.value

    if(this.#vinIsBlank(value)) return false

    return true
  }

  #renderError() {
    this.vin.classList.add('invalid')
    this.vin.parentNode.appendChild(this.#buildErrorMessage())
  }

  #vinIsBlank(value) {
    if(value == '') {
      this.errorMessage = 'VIN no puede estar en blanco'
      return true
    }
    return false
  }

  #vinIsInvalid(value) {
    if(!this.vinRegex.test(value)) {
      this.errorMessage = 'VIN invalido'
      return true
    }
    return false
  }

  #buildErrorMessage() {
    let label = this.element.querySelector('.error-label')
    if(!label) label = document.createElement('label')
    label.classList.add('error-label')
    label.textContent = this.errorMessage
    label.style.display = 'block'
    return label
  }
}
